/* aaa-testimonials.js
 *
 * Shuffles the testimonial cards on page load and shows only the
 * configured max-visible count. The server renders all matching
 * testimonials in the DOM; this script picks N at random and hides
 * the rest with the [hidden] attribute.
 *
 * On mobile (below the section's CSS breakpoint) the layout becomes a
 * horizontal carousel, so all matching cards stay visible — but their
 * order is still randomised on each load so the carousel leads with a
 * different quote every visit rather than always showing the same one
 * first.
 *
 * Re-runs on Shopify section:load events so the theme editor preview
 * stays in sync as the merchant adjusts settings, and on resize when
 * the viewport crosses the mobile/desktop boundary.
 */
(function () {
  // Match the CSS mobile breakpoint (max-width: 749px). On mobile the
  // grid becomes a horizontal carousel and we want ALL matching cards
  // visible so the user can scroll through them. On desktop we shuffle
  // and trim to the configured max-visible count.
  var MOBILE_BREAKPOINT = 749;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function shuffleSection(section) {
    if (!section) return;

    var grid = section.querySelector('[data-aaa-testimonials-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('[data-aaa-testimonial-card]')
    );

    if (cards.length <= 1) return;

    // Fisher-Yates shuffle the card array.
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cards[i];
      cards[i] = cards[j];
      cards[j] = tmp;
    }

    if (isMobile()) {
      // Mobile carousel: keep every card visible (the user scrolls
      // horizontally), but reorder the DOM so a different quote leads
      // the carousel on each load.
      cards.forEach(function (c) {
        c.hidden = false;
        grid.appendChild(c);
      });
      return;
    }

    // Desktop: reorder the DOM to the shuffled sequence, then show only
    // the first maxVisible cards and hide the rest.
    var maxVisible = parseInt(section.dataset.maxVisible || '3', 10);
    cards.forEach(function (card, idx) {
      grid.appendChild(card);
      card.hidden = cards.length > maxVisible && idx >= maxVisible;
    });
  }

  function init() {
    var sections = document.querySelectorAll('.aaa-testimonials');
    sections.forEach(shuffleSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-shuffle when the theme editor reloads a section.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.aaa-testimonials');
    if (section) shuffleSection(section);
  });

  // Re-evaluate on viewport crossing the mobile/desktop breakpoint
  // (rotation, window resize). Debounced so rapid resizes don't thrash.
  var resizeTimeout;
  var lastIsMobile = isMobile();
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      var nowIsMobile = isMobile();
      if (nowIsMobile !== lastIsMobile) {
        lastIsMobile = nowIsMobile;
        init();
      }
    }, 150);
  });
})();
